"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidDate = function isValidDate(message) {
  return function (_ref) {
    var field = _ref.field;

    // This is not an 'isRequired' validator
    if (!field.value) {
      return true;
    } // Date format fixed to DD/MM/YYYY & strict validation enabled


    var date = (0, _moment.default)(field.value, 'DD/MM/YYYY', true);
    return [date.isValid(), message || 'Please enter a valid date'];
  };
};

var _default = isValidDate;
exports.default = _default;
//# sourceMappingURL=isValidDate.js.map